import Image from "next/image";
import { getCDNImageUrl } from "@/utils/Common";
import { S3_BASE_URL } from "@/constastants/Constant";

const ReachUs = ({ selectedTab }) => {
  const getImagePath = () => {
    // Define the image paths based on the selected tab
    switch (selectedTab) {
      case "1":
        return {
          imageUrl:
            `${S3_BASE_URL}/mumbai-address.webp`,
          goTo: "https://maps.app.goo.gl/qDsszqpawfHAjwqN9",
        };
      case "2":
        return {
          imageUrl:
            `${S3_BASE_URL}/products/icons/1709271122.webp`,
          goTo: "https://maps.app.goo.gl/qxVn6cFLicMfGcvb9",
        };
      case "3":
        return {
          imageUrl:
            `${S3_BASE_URL}/Screenshot_2025-04-23_BW.webp`,
          goTo: "https://maps.app.goo.gl/X4z6kkYnsayNboHA6",
        };
      default:
        return {
          imageUrl:
            `${S3_BASE_URL}/Screenshot_2025-04-23_BW.webp`,
          goTo: "https://maps.app.goo.gl/X4z6kkYnsayNboHA6",
        };
    }
  };

  return (
    <div className="flex flex-col sm:ml-[0]  md:py-20 sm:mt-[0] ">
      <a href={getImagePath().goTo} target="_blank">
        <img
          src={getImagePath().imageUrl}
          alt="logo"
          width={1500}
          height={200}
          className="sm:ml-[0] w-full sm:translate-x-[10]"
        />
      </a>
    </div>
  );
};

export default ReachUs;
